import { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom";
import _ from "lodash";
import { motion, useMotionValueEvent, useScroll } from "framer-motion";
import { Navigation, Thumbs, FreeMode, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import consts from "../libs/consts";
import { useHeader, useLang, useMenu, usePopup, useUser } from "../zustand/store";
import { dataFormat, elapsedTime } from "../utils/utils";
import routes from "../libs/routes";

import Button from "./Button";
import Profile from "./Profile";
import { ContentTypeText, LangText } from "../zustand/dict";
import moment from "moment";
import { makeOptionList } from "../libs/makeOption";


const getRandImgURL = (index = 0) => {
    index = index % 5;
    const randList = [
        { w: 1024, h: 682 },
        { w: 1024, h: 576 },
        { w: 1024, h: 1024 },
        { w: 576, h: 1024 },
        { w: 682, h: 1024 },
    ]

    return `https://placehold.co/${randList[index]?.w}x${randList[index]?.h}`
}

export default function ArtDetailPopup(props) {
    const {
        open = false,
        setOpen = () => { },
        idx,
        data,
        photoIndex = 0,
        likeClick
    } = props;
    const { getMenu } = useMenu();

    const layoutList = [
        { w: 528, h: 351.22 },
        { w: 528, h: 296.04 },
        { w: 528, h: 528 },
        { w: 396, h: 704 },
        { w: 396, h: 592.68 },
    ]

    const { setHeaderMode } = useHeader();
    const { token, user } = useUser();
    const { country, getLang } = useLang();

    const containRef = useRef(null);
    const [thumbsSwiper, setThumbsSwiper] = useState({});
    const [index, setIndex] = useState(0);
    const [imgSrc, setImgSrc] = useState("");

    const [like, setLike] = useState(false)
    const [optionList, setOptionList] = useState([]);


    function imageDownFunc(url) {
        fetch(url, {
            method: "GET",
            headers: {}
        })
            .then(response => {
                response.arrayBuffer().then(function (buffer) {
                    const url = window.URL.createObjectURL(new Blob([buffer]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "download.png"); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            })
            .catch(err => {
                console.log(err);
            });
    }

    const downClick = () => {
        let fileIndex = thumbsSwiper.activeIndex
        if (fileIndex >= 0) {
            imageDownFunc(consts.imgUrl + data?.art?.files[fileIndex]?.filePath)
        }
    }

    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden';
            // thumbsSwiper.slideTo(0)
            thumbsSwiper.slideTo(photoIndex)
            setHeaderMode({
                mode: consts.headerMode.BACK,
                onBackClick: () => {
                    setOpen(false)
                }
            })

            if (data) {
                setOptionList(v => {
                    let settingData = [];
                    // settingData.push(getLang({ key: data?.menuTitleKey }))
                    settingData.push(<LangText id={data?.menuTitleKey} />)

                    let addOption = makeOptionList(data?.art)
                    let resultOption = addOption.map(v => {
                        return String(v).indexOf("option_") >= 0 ? <LangText id={v} /> : v
                    })
                    return [...settingData, ...resultOption]
                })
                setLike(data.art?.myLike)
            }
        }
        else {
            document.body.style.overflow = '';
            if (containRef.current.scrollTop != 0) containRef.current.scrollTop = 0
            setHeaderMode({
                mode: consts.headerMode.NORMAL,
            })
        }
    }, [open])

    useEffect(() => {
        return () => {
            setHeaderMode({
                mode: consts.headerMode.NORMAL,
            })
        }
    }, [])



    // return <div className={`art_detail_popup ${open ? "on" : ""}`}>
    return <motion.nav
        ref={containRef}
        className={`art_detail_popup`}
        initial={{ opacity: 0, display: "none" }}
        variants={{
            visible: { opacity: 1, display: "block" },
            hidden: { opacity: 0, display: "none" },
        }}
        animate={open ? "visible" : "hidden"}
        transition={{ type: "keyframes" }}
    >
        <div className="contain">

            <div className="img_box">
                <div className="swipe_box" >
                    <Swiper
                        onSwiper={setThumbsSwiper}
                        spaceBetween={20}
                        slidesPerView={1}
                        // freeMode={true}
                        watchSlidesProgress={true}
                        modules={[FreeMode, Navigation, Thumbs, Pagination]}
                        pagination={{
                            el: "#containerForBullets",
                            type: "bullets",
                            bulletClass: "swiper-custom-bullet",
                            bulletActiveClass: "swiper-custom-bullet-active",
                            clickable: true,
                        }}
                    >
                        {data?.art?.files?.map(v => {
                            return <SwiperSlide className="swipe_item" onClick={() => { }}>
                                <img src={`${consts.imgUrl + v?.filePath}`} />
                            </SwiperSlide>
                        })}
                    </Swiper>
                    <div id="containerForBullets"></div>
                </div>
            </div>
            <div className="info_box">
                <div style={{
                    position: "absolute",
                    top: 24,
                    right: 24
                }}>
                    <button className='exit_btn' onClick={() => { setOpen(false) }} />
                </div>

                <div className="prompt">
                    {data?.art?.prompt ? data?.art?.prompt : "none"}
                </div>
                <div className="tag_box">
                    {optionList.map((v) => {
                        return <div className="tag_item">{v}</div>
                    })}
                </div>

                <div className="user_box">
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between"
                    }}>
                        <div className="name_date">
                            <p className="body1 color-black">{data?.art?.user?.name}</p>
                            <p className="caption1 color-g500">{elapsedTime(data?.art?.createAt, country)}</p>
                        </div>
                        <div className="btn_box">
                            <button className={`down_blk_btn`} onClick={downClick} />
                            {likeClick && <button className={`like_blk_btn ${like ? "on" : ""}`} onClick={() => {
                                setLike(!like)
                                likeClick()
                            }} disabled={!token} />}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </motion.nav>
}